import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { APPROVAL_PROFILE_360, APPROVAL_PROFILE_360_SUCCESS, APPROVAL_PROFILE_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* approvalProfile360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];


    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/accept-reject`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: APPROVAL_PROFILE_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: APPROVAL_PROFILE_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_PROFILE_360_ERROR, payload: error });
  }
}

export function* watchApprovalProfile360() {
  yield takeEvery(APPROVAL_PROFILE_360, approvalProfile360);
}

function* approvalProfile360Saga() {
  yield all([fork(watchApprovalProfile360)]);
}

export default approvalProfile360Saga;
